export default __webpack_public_path__ + "static/media/logowhite.3c83978f.svg";